// extracted by mini-css-extract-plugin
export default {"shell":"MainLayout_shell__jDI8M","main":"MainLayout_main__kvy0P","sidebar":"MainLayout_sidebar__CCYIL","content":"MainLayout_content__Kk1fw"};